import { useAuth0 } from "@auth0/auth0-react";
import {
  Button,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import UnauthenticatedLayout from "../layout/UnauthenticatedLayout";

interface Props { }

const Login: FunctionComponent<Props> = (props: Props): JSX.Element => {
  const { loginWithRedirect } = useAuth0();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useTranslation();

  return (
    <UnauthenticatedLayout>
      <Stack padding={2} spacing={4} alignItems={"center"} textAlign={"center"}>
        <Typography variant={isSmallScreen ? "h4" : "h2"}>
          TeacherActive E-Timesheet Portal
        </Typography>

        <Typography variant="body1">{t("login.welcomeMessage")}</Typography>
        <Button
          variant="contained"
          size={isSmallScreen ? "small" : "medium"}
          sx={{ width: "fit-content" }}
          onClick={() => loginWithRedirect()}
        >
          {t("login.loginButton")}
        </Button>
      </Stack>
    </UnauthenticatedLayout>
  );
};

export default Login;
